module.exports = __webpack_public_path__ + "static/image/history/pc/201506.ver2_0_2.jpg?c8a08b5d";